import ApiService from '@/services/api.service';

const PatientPortalChangeInfoService = {
    getAll(parameters) {
        const requestData = {
            method: 'get',
            url: '/PatientPortalChangeInfoRequests/',
            headers: {},
            params: parameters
        };
        return ApiService.customRequest(requestData);
    },

    get(id) {
        return ApiService.get(`/PatientPortalChangeInfoRequests/${id}`);
    },

    update(id, data) {
        return ApiService.put(`/PatientPortalChangeInfoRequests/${id}`, data);
    },

    discard(id, isNewRequest) {
        const requestData = {
            method: 'put',
            url: `/PatientPortalChangeInfoRequests/Discard/${id}`,
            headers: {},
            params: { isNewRequest }
        };
        return ApiService.customRequest(requestData);
    },

    getNewRequestsCount() {
        return ApiService.get('/PatientPortalChangeInfoRequests/count-new-requests');
    }
};

export default PatientPortalChangeInfoService;
